export default __webpack_public_path__ + "static/char-s-35-ko-341c9c3d5325a4465513b50fd8477e57.webp";